module.exports = "<dk-message *ngFor=\"let message of messages\" [text]=\"message.content\" [type]=\"message.type\" id=\"info-box-messages\"></dk-message>";